import { Component, OnInit, HostBinding, ElementRef, signal, AfterViewInit, inject, input, contentChild } from "@angular/core";
import { DeviceService } from "../../../../core-ui/services/device.service";
import { TinyColor } from "@ctrl/tinycolor";
import { CardBodyComponent } from "../card-body/card-body.component";

export type CardType =
  | "danger"
  | "warning"
  | "info"
  | "container"
  | "ghost"
  | "success"
  | "snapshot"
  | "control-options";

@Component({
  selector: "av-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"],
  standalone: false,
})
export class CardComponent implements OnInit, AfterViewInit {
  host = inject<ElementRef<HTMLDivElement>>(ElementRef);

  readonly popup = input(false);
  readonly backdrop = input(true);
  readonly menu = input(false);
  readonly vAlign = input<"top" | "bottom">(undefined);
  readonly hAlign = input<"left" | "right" | "center">(undefined);
  readonly type = input<CardType>("container");
  readonly arrow = input<"bottom" | "bottom-left" | "bottom-right" | "top" | "left" | "right" | "top-left" | "top-right" | "left-top">(undefined);

  readonly role = input<string>(undefined);

  readonly cardBody = contentChild(CardBodyComponent);

  private supportsBackdropBlur = true;
  // iconMode = signal("light");

  constructor() {
    this.supportsBackdropBlur = !DeviceService.isFirefox;
  }

  @HostBinding("class") get class() {
    const type = this.type();
    return {
      "panel-error": this.type() === "danger",
      "panel-warn": this.type() === "warning",
      "panel-success": this.type() === "success",
      "panel-info": this.type() === "info",
      "panel-secondary": this.isSecondary,
      "panel-control-options": this.type() === "control-options",
      "panel-backdrop-blur":
        this.supportsBackdropBlur &&
        this.backdrop() &&
        (type === "container" || type === "control-options"),
      "panel-popup": this.popup(),
      "panel-popup-top": this.popup() && this.vAlign() === "top",
      "panel-popup-bottom": this.popup() && this.vAlign() === "bottom",
      "panel-popup-left": this.popup() && this.hAlign() === "left",
      "panel-popup-right": this.popup() && this.hAlign() === "right",
      "panel-popup-center": this.popup() && this.hAlign() === "center",
      "panel-popup-menu": this.menu(),
      "panel-arrow": !!this.arrow(),
      "panel-arrow-down": this.arrow() === "bottom",
      "panel-arrow-down-left": this.arrow() === "bottom-left",
      "panel-arrow-down-right": this.arrow() === "bottom-right",
      "panel-arrow-up": this.arrow() === "top",
      "panel-arrow-left": this.arrow() === "left",
      "panel-arrow-left-top": this.arrow() === "left-top",
      "panel-arrow-right": this.arrow() === "right",
      "panel-arrow-up-left": this.arrow() === "top-left",
      "panel-arrow-up-right": this.arrow() === "top-right",
      "panel-ghost": this.type() === "ghost",
      [`panel-body-size-${this.cardBody()?.size() || "md"}`]: true,
    };
  }

  ngOnInit() {
    this.host.nativeElement.setAttribute(
      "role",
      this.role() ?? (this.popup() ? "dialog" : "group")
    );
  }

  ngAfterViewInit(): void {
    // if (this.isSecondary) {
    //   this.iconMode.set(this.isLightBackground ? "dark" : "light");
    // }
  }

  public get isSecondary() {
    return ["info", "success", "warning", "error", "danger"].includes(
      this.type()
    );
  }

  public get isLightBackground() {
    const style = getComputedStyle(this.host.nativeElement);
    return new TinyColor(style.backgroundColor).isLight();
  }
}
